import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Button, CircularProgress, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, TextField, Typography, } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { useInboxClient, useInboxNotification } from '../../hooks';
import { NotificationContentSectionWrapper } from '../NotificationContentSectionWrapper';
export const NotificationResponse = ({ notification, onReload }) => {
    const { t } = useAlertUiTranslation();
    const inboxClient = useInboxClient();
    const [selectedOption, setSelectedOption] = React.useState('');
    const [customResponse, setCustomResponse] = React.useState('');
    const [error, setError] = React.useState();
    const [submitting, setSubmitting] = React.useState(false);
    const [customValueError, setCustomValueError] = React.useState();
    const { mutate } = useInboxNotification(notification.id);
    const responseOptionsAvailable = (notification.responseOptions && Object.keys(notification.responseOptions).length > 0) || notification.responseIsFreeText;
    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        setError(undefined);
    };
    const handleSubmit = () => {
        if (selectedOption === undefined) {
            setError(t('inboxDetails.valueRequired'));
            return;
        }
        if (selectedOption === 'custom' && (!customResponse || customResponse.trim().length === 0)) {
            setCustomValueError(t('inboxDetails.valueRequired'));
            return;
        }
        setSubmitting(true);
        const response = selectedOption && selectedOption === 'custom' ? customResponse.trim() : selectedOption;
        inboxClient
            .saveResponse(notification.id, response)
            .then(() => {
            onReload(false);
            mutate().finally(() => setSubmitting(false));
            showAlertSnackbar({
                message: t('pages.edit.snackbar.inbox.responseSubmitted'),
                type: 'success',
                autoHideDuration: 1000,
            });
        })
            .catch(handleErrorDialog);
    };
    return (React.createElement(NotificationContentSectionWrapper, { heading: t('common.response') }, submitting ? (React.createElement(CircularProgress, null)) : (React.createElement(React.Fragment, null,
        !responseOptionsAvailable && React.createElement(Typography, { variant: 'body2' }, t('inboxDetails.noResponseOptions')),
        responseOptionsAvailable && notification.response && !notification.waitingForResponse && (React.createElement(Typography, { variant: 'body2', sx: { wordBreak: 'break-word' } }, t('inboxDetails.youResponded', { value: getResponseText(notification) }))),
        responseOptionsAvailable && !notification.response && !notification.waitingForResponse && (React.createElement(Typography, { variant: 'body2' }, t('inboxDetails.messageIsNoLongerAvailableForResponse'))),
        responseOptionsAvailable && notification.waitingForResponse && (React.createElement(React.Fragment, null,
            React.createElement(FormControl, { component: 'fieldset', sx: { display: 'block', px: 2, pb: 1 } },
                error && React.createElement(FormHelperText, { error: true }, error),
                React.createElement(RadioGroup, { value: selectedOption, onChange: handleChange, "data-test": 'select-response-option' },
                    (notification === null || notification === void 0 ? void 0 : notification.responseOptions) &&
                        Object.entries(notification.responseOptions).map(([key, value]) => (React.createElement(FormControlLabel, { sx: { p: 0.5 }, key: key, value: key, control: React.createElement(Radio, { color: 'primary' }), label: React.createElement(Typography, { sx: { wordBreak: 'break-word' } }, value), disabled: !notification.waitingForResponse }))),
                    notification.responseIsFreeText && (React.createElement(FormControlLabel, { key: 'custom', value: 'custom', control: React.createElement(Radio, { color: 'primary' }), label: t('inboxDetails.custom'), disabled: !notification.waitingForResponse }))),
                selectedOption === 'custom' && (React.createElement(TextField, { value: customResponse, variant: 'outlined', size: 'small', label: t('inboxDetails.customResponseValue'), onChange: (event) => setCustomResponse(event.target.value), disabled: !notification.waitingForResponse, fullWidth: true, error: !!customValueError, helperText: customValueError, "data-test": 'custom-response' }))),
            React.createElement(Button, { variant: 'contained', color: 'primary', onClick: handleSubmit }, t('inboxDetails.submit'))))))));
};
function getResponseText(notification) {
    var _a;
    const option = Object.entries((_a = notification === null || notification === void 0 ? void 0 : notification.responseOptions) !== null && _a !== void 0 ? _a : {}).find((opt) => opt[0] === notification.response);
    return option ? option[1] : notification.response;
}
